// extracted by mini-css-extract-plugin
export default {"asideBox":"index_asideBox_UH8Q-","a04":"index_a04_CRNtZ","a03":"index_a03_J7ZcB"};